<div class="responsive-video-wrapper">
  <ng-content>
  </ng-content>
</div>
